import types from '@/actions/types';
import useRobotCommand from '@/composables/useRobotCommand';
import useAnalytics from '@/composables/useAnalytics';
import Base from '@/actions/base';

export default class RobotCommand extends Base {
  constructor(params) {
    super(params, types.ROBOT_COMMAND);

    this.rc = useRobotCommand();
  }

  execute() {
    const { trackAction } = useAnalytics();
    trackAction(this);

    return new Promise((resolve) => {
      this.resolve = resolve;
      this.rc.executeRobotCommand(this.params, this.resolve);
    });
  }

  stop() {
    this.rc.stopRobotCommandCommunication();
    if (this.resolve) {
      this.resolve();
    }
  }
}
